export const objectWithKeys: <T>(obj: Record<string, T>, keys: string[], value: T) => Record<string, T> = <T>(
  obj: Record<string, T>,
  keys: string[],
  value: T
) => {
  const newKeys: Record<string, T> = {};

  for (const key of keys) {
    newKeys[key] = value;
  }

  return {
    ...obj,
    ...newKeys,
  };
};
